import { Link } from "react-router-dom"
import styled from "styled-components"

export const MyListWrapper = styled.div`
  --my-food-top-navigation-height: 46.4px;
  height: calc(100% - var(--my-food-top-navigation-height));
`

export const FoodList = styled.div`
  --create-food-link-height: 56px;
  height: calc(100% - var(--create-food-link-height));
  overflow-y: auto;
  padding: 0 var(--app-horizontal-padding);
`

export const CreateMyFoodLinkWrapper = styled.div`
  padding: 8px var(--app-horizontal-padding);
`

export const CreateMyFoodLink = styled(Link)`
  display: flex;
  padding: 7px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Schemes-Primary, #0da3ba);
  background: var(--White, #fff);
  font-size: 14px;
  font-weight: 700;
  line-height: 14px; /* 100% */
  letter-spacing: 0.14px;
  color: var(--Schemes-Primary, #0da3ba);
  text-decoration: none;
  gap: 8px;
  height: 40px;
`
